@if (!isSeller) {
  <div class="pb-3">
    <a href="operator/shop" class="font-semibold">
      <i
        class="pi pi-angle-left"
        style="border: 1px solid; border-radius: 50%; vertical-align: middle; padding-top: 1px; padding-right: 1px"></i>
      <span class="pl-1" style="vertical-align: bottom">{{ "shop.returnToShopList" | translate }}</span>
    </a>
  </div>
}
<div class="font-semibold text-xl pb-4">
  <i class="pi pi-shop bg-icon"></i>
  <span class="pl-2" style="font-size: 1.2rem">{{ "shop.shop" | translate }}</span>
</div>
<p-card class="relative">
  <div class="flex pb-3">
    <div class="flex-1">
      <p-select
        #dropdown
        styleClass="shop-selector"
        [options]="relatedShops"
        [style]="{minWidth: '300px'}"
        [(ngModel)]="selectedShop"
        (onChange)="onShopChange()"
        [disabled]="!isSeller || relatedShops.length == 1">
        <ng-template let-selectedItem pTemplate="selectedItem">
          <span class="inline font-bold line-height-1">{{ selectedShop?.shopName }} -</span>
          <span class="inline line-height-1">
            {{ selectedShop?.shopChannel.channelName | translate}}
          </span>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <span class="inline font-bold line-height-1">{{ item?.shopName }} -</span>
          <span class="inline line-height-1">
            {{ item?.shopChannel.channelName | translate}}
          </span>
        </ng-template>
      </p-select>
    </div>

    <div>
      <p-button [outlined]="true" styleClass="vertical-align-middle" (click)="openHistoryDialog()">
        <i class="pi pi-clock"></i>
        <span class="pl-2">{{ "global.history" | translate }}</span>
      </p-button>
    </div>
  </div>
  <p-tabs [value]="activeTabIndex" (valueChange)="onTabChange($event)">
    <p-tablist>
      <p-tab [value]="0">{{ 'shop.shopManagement' | translate }}</p-tab>
      @if (isSeller || isSuperAdmin || isOperatorAdmin) {
        <p-tab [value]="1">{{ 'shop.aggregator' | translate }}</p-tab>
      }
    </p-tablist>

    <p-tabpanels>
      <p-tabpanel [value]="0">
        <div class="info-shop grid pt-5 pb-5">
          <div [class]="isSeller ? 'col-12 grid' : 'lg:col-9 md:col-8 sm:col-12 grid'">
            <!-- ids -->
            <div class="lg:col-3 md:col-6 sm:col-12">
              <div>
                <span class="info-label">{{ "shop.idsBOMP" | translate }}</span>
                <span class="info-value">{{ shopInfo?.shopCode }}</span>
              </div>
            </div>
            <!-- status -->
            <div class="lg:col-3 md:col-6 sm:col-12">
              <div class="pb-4">
                <span class="info-label">{{ "shop.compteStatus" | translate }}</span>
                <p-tag [severity]="getSeverity(shopInfo?.shopStatus?.statusCode)">
                  {{ shopInfo?.shopStatus.statusCode | translate }}
                </p-tag>
              </div>
            </div>
            <!-- channel -->
            <div class="lg:col-3 md:col-6 sm:col-12">
              <div>
                <span class="info-label">{{ "global.distributionChannel" | translate }}</span>
                <span class="info-value">{{ shopInfo?.channel | translate }}</span>
              </div>
            </div>
            <!-- import -->
            <div class="lg:col-3 md:col-6 sm:col-12">
              <div class="pb-4 show-info">
                <span class="info-label">
                  <span class="pr-3">{{ "global.importRight" | translate }}</span>
                  @if(!shopInfo?.operator) {
                    <span class="primary-link font-bold text-xs"
                      *ngxPermissionsOnly="['PERMISSION_EDIT_IMPORT', 'PERMISSION_SUPER_ADMIN']">
                      <i class="pi pi-pencil font-bold" style="font-size: 0.65rem"></i>
                      <span class="pl-1" (click)="importVisible = true">Modifier</span>
                    </span>
                  }
                </span>
                @if (shopInfo?.shopCanImport) {
                  <p-tag severity="success">{{ "global.authorized" | translate }}</p-tag>
                } @else {
                  <p-tag severity="warn">{{ "global.notAuthorized" | translate }}</p-tag>
                }
              </div>
            </div>
            <!-- entité légale -->
            <div class="lg:col-3 md:col-6 sm:col-12">
              <div>
                <span class="info-label">{{ "global.legalEntity" | translate }}</span>
                <span class="info-value">{{ shopInfo?.legalEntityName }}</span>
              </div>
            </div>
            <!-- email -->
            <div class="lg:col-3 md:col-6 sm:col-12">
              <div>
                <span class="info-label">{{ "global.linkedEmail" | translate }}</span>
                <span class="info-value">{{ shopInfo?.principalAdminEmail }}</span>
              </div>
            </div>
            <!-- creation date -->
            <div class="lg:col-3 md:col-6 sm:col-12">
              <div class="pb-4">
                <span class="info-label">{{ "global.creation" | translate }}</span>
                <span class="info-value">
                  @if (shopInfo?.creationDate?.indexOf("/") > -1) {
                    {{ shopInfo?.creationDate }}
                  } @else {
                    {{ shopInfo?.creationDate | date: "dd/MM/yyyy HH:mm" }}
                  }
                </span>
              </div>
            </div>
            <!-- date import -->
            <div class="lg:col-3 md:col-6 sm:col-12">
              <div class="pb-4">
                <span class="info-label">{{ "global.lastImport" | translate }}</span>
                <span class="info-value">{{ shopInfo?.lastImportDate | date: "dd/MM/yyyy HH:mm" }}</span>
              </div>
            </div>
          </div>

          <!-- scores -->
          <div class="lg:col-3 md:col-4 sm:col-12"
            *ngxPermissionsOnly="['PERMISSION_VIEW_SCORE', 'PERMISSION_EDIT_SCORE', 'PERMISSION_SUPER_ADMIN']">
            <div class="show-info">
              <div class="info-label" *ngxPermissionsOnly="['PERMISSION_EDIT_SCORE', 'PERMISSION_SUPER_ADMIN']">
                <span style="padding-right: 6rem">{{ "shop.score" | translate }}</span>
                @if(!shopInfo?.operator) {
                  <span class="primary-link font-bold text-xs">
                    <i class="pi pi-pencil font-bold" style="font-size: 0.65rem"></i>
                    <span class="pl-1" (click)="scoreVisible = true">{{ "buttons.edit" | translate }}</span>
                  </span>
                }
              </div>
              <div>
                <div class="grid">
                  <div class="col-6">
                    <span class="info-value-score flex align-items-end">
                      {{ "shop.ref" | translate }}
                      <i class="ml-2 pi pi-info-circle color-link-primary"
                        pTooltip="{{ 'shop.refTooltip' | translate }}"></i>
                    </span>
                  </div>
                  <div class="col-6">
                    @if (shopInfo?.scoreRef) {
                      @if (shopInfo?.scoreRef < 40) {
                        <p-tag severity="danger">{{ shopInfo?.scoreRef }}</p-tag>
                      } @else if (shopInfo?.scoreRef < 70) {
                        <p-tag severity="secondary">{{ shopInfo?.scoreRef }}</p-tag>
                      } @else {
                        <p-tag severity="success">{{ shopInfo?.scoreRef }}</p-tag>
                      }
                    }
                  </div>
                </div>
                <div class="grid">
                  <div class="col-6">
                    <span class="info-value-score flex align-items-end">
                      {{ "shop.media" | translate }}
                      <i class="ml-2 pi pi-info-circle color-link-primary"
                        pTooltip="{{ 'shop.mediaTooltip' | translate }}"></i>
                    </span>
                  </div>
                  <div class="col-6">
                    @if (shopInfo?.scoreMedia) {
                      @if (shopInfo?.scoreMedia < 40) {
                        <p-tag severity="danger">{{ shopInfo?.scoreMedia }}</p-tag>
                      } @else if (shopInfo?.scoreMedia < 70) {
                        <p-tag severity="secondary">{{ shopInfo?.scoreMedia }}</p-tag>
                      } @else {
                        <p-tag severity="success">{{ shopInfo?.scoreMedia }}</p-tag>
                      }
                    }
                  </div>
                </div>
                <div class="grid">
                  <div class="col-6">
                    <span class="info-value-score flex align-items-end">
                      {{ "shop.ad" | translate }}
                      <i class="ml-2 pi pi-info-circle color-link-primary"
                        pTooltip="{{ 'shop.adTooltip' | translate }}"></i>
                    </span>
                  </div>
                  <div class="col-6">
                    @if (shopInfo?.scoreAd) {
                      @if (shopInfo?.scoreAd < 40) {
                        <p-tag severity="danger">{{ shopInfo?.scoreAd }}</p-tag>
                      } @else if (shopInfo?.scoreAd < 70) {
                        <p-tag severity="secondary">{{ shopInfo?.scoreAd }}</p-tag>
                      } @else {
                        <p-tag severity="success">{{ shopInfo?.scoreAd }}</p-tag>
                      }
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="separator"></div>
        <div class="table-actions">
          <span class="table-action">{{ "shop.userList" | translate }}</span>
          <p-button [text]="true" (click)="exportShopUsers()">
            <i class="pi pi-upload pr-2"></i>
            <span class="table-action-link">{{ "buttons.export" | translate }}</span>
          </p-button>
          @if(!shopInfo?.operator) {
            <p-button [text]="true" (click)="openUpdateUserDialog()"
              *ngxPermissionsOnly="['PERMISSION_MANAGE_ROLES_AND_USERS', 'PERMISSION_MANAGE_USERS', 'PERMISSION_SUPER_ADMIN']">
              <i class="pi pi-user-plus pr-2"></i>
              <span class="table-action-link">{{ "shop.addUser" | translate }}</span>
            </p-button>
          }
        </div>

        <p-table
          class="table-shadow"
          [value]="users"
          [scrollable]="true"
          scrollHeight="500px"
          [paginator]="true"
          [rows]="5"
          [loading]="loading"
          [tableStyle]="{ 'min-width': '50rem' }"
          [showCurrentPageReport]="true"
          [currentPageReportTemplate]="'table.currentPageReportTemplate' | translate"
          [rowsPerPageOptions]="[5, 10, 25, 50, 100]">
          <ng-template #header>
            <tr>
              @for (header of headers; track $index) {
                <th [pSortableColumn]="header.id" [id]="header.id">
                  <span>{{ header.value | translate }}</span>
                  <p-sortIcon [field]="header.id" />
                </th>
              }
            </tr>
          </ng-template>
          <ng-template #body let-user>
            <tr>
              @for (header of headers; track $index) {
                <td>
                  @if (header.type == "tag") {
                    <p-tag [severity]="getSeverity(user[header.id])">
                      {{ user[header.id] | translate }}
                    </p-tag>
                  } @else if (header.type == "status") {
                    <p-tag
                      [severity]="getSeverity(user[header.id].active)"
                      value="{{ user[header.id].active | translate }}">
                    </p-tag>
                  } @else if (header.type == "date") {
                    {{ user[header.id].value | date: "dd-MM-yyyy" }}
                  } @else if (header.type == "buttons") {
                    @if (!hiddenValue(user)) {
                      @if(!user.operator) {
                        <p-button [text]="true" icon="pi pi-user-edit"
                          pTooltip="{{ 'tooltips.editUser' | translate }}"
                          (click)="openUpdateUserDialog(user)">
                        </p-button>
                      }
                      @if (user.active == "ACTIVE") {
                        <p-button [text]="true" icon="pi pi-pause" severity="danger"
                          pTooltip="{{ 'tooltips.disableUser' | translate }}"
                          (click)="openEditStatusUserDialog(user, 'disable')">
                        </p-button>
                      } @else {
                        <p-button [text]="true" icon="pi pi-play" severity="success"
                          pTooltip="{{ 'tooltips.enableUser' | translate }}"
                          (click)="openEditStatusUserDialog(user, 'enable')">
                        </p-button>
                      }
                    }
                  } @else {
                    {{ user[header.id] }}
                  }
                </td>
              }
            </tr>
          </ng-template>
        </p-table>
      </p-tabpanel>

      @if (isSeller || isSuperAdmin || isOperatorAdmin) {
        <p-tabpanel [value]="1">
          <div class="col-6 grid">
            <div class="col-4">
              <span class="info-value">{{ "shop.idBoutique" | translate }}</span>
            </div>
            <div class="col-8">
              <span class="info-label">{{ shopInfo?.shopCode }}</span>
            </div>
          </div>

          <p-message class="messages" severity="info" [closable]="false">
            <ng-template #icon>
            <i class="pi pi-info-circle text-lg-custom"></i>
            </ng-template>
            <div class="ml-2">
              <div class="font-semibold">
                {{ message.detail | translate }}
                <a class="link" target="_blank" href="/docapi">
                  {{ message.link | translate }}
                </a>
              </div>
            </div>
          </p-message>

          <div class="table-actions mt-5">
            <span class="table-action">{{ "shop.associatedAggregatorList" | translate }}</span>
            @if(!isOperatorAdmin) {
              <p-button [link]="true" (click)="openAssociateAgregatorDialog()">
                <i class="pi pi-plus-circle"></i>
                <span class="font-semibold ml-2">{{ "shop.associateAggregator" | translate }}</span>
              </p-button>
            }
          </div>

          <p-table
            [value]="aggregators"
            [scrollable]="true"
            scrollHeight="500px"
            [tableStyle]="{ 'min-width': '50rem' }"
            [rows]="5"
            [rowHover]="true">
            <ng-template #header>
              <tr>
                @for (header of headersAggregators; track header.id) {
                  <th [id]="header.id">{{ header.value | translate }}</th>
                }
                @if(!isOperatorAdmin) {
                  <th id="actions"></th>
                }
              </tr>
            </ng-template>
            <ng-template #body let-aggregator>
              <tr class="hover-row">
                @for (header of headersAggregators; track $index) {
                  <td>
                    @if (header.type == "tag") {
                      @if (aggregator[header.id]) {
                        <p-tag severity="success">{{ 'shop.associated' | translate }}</p-tag>
                      } @else {
                        <p-tag severity="danger">{{ 'shop.disassociated' | translate }}</p-tag>
                      }
                    } @else if (header.type == "date") {
                      {{ aggregator[header.id].value | date: "dd-MM-yyyy" }}
                    } @else {
                      {{ aggregator[header.id] }}
                    }
                  </td>
                }
                @if(!isOperatorAdmin) {
                  <td>
                    @if (aggregator.isAssociated) {
                      <p-button [text]="true" icon="pi pi-pause" severity="danger"
                        label="{{ 'shop.disableAggregator' | translate }}"
                        (click)="openChangeAssociationDialog(aggregator, false)">
                      </p-button>
                    } @else {
                      <p-button [text]="true" icon="pi pi-play" severity="success"
                        label="{{ 'shop.enableAggregator' | translate }}"
                        (click)="openChangeAssociationDialog(aggregator, true)">
                      </p-button>
                    }
                  </td>
                }
              </tr>
            </ng-template>
          </p-table>
        </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
</p-card>

<p-dialog
  [dismissableMask]="true"
  header="Header"
  [(visible)]="importVisible"
  (onHide)="hideModalImport()"
  [modal]="true"
  [style]="{ width: '40rem' }"
  draggable="false">
  <ng-template pTemplate="header">
    <div class="inline-flex align-items-center justify-content-center gap-2">
      <span class="font-bold white-space-nowrap">{{ "global.importRight" | translate }}</span>
    </div>
  </ng-template>
  <div>
    <div class="flex flex-wrap gap-5">
      <div class="flex w-11rem">
        <span class="text-secondary">{{ "global.importRight" | translate }}</span>
      </div>
      @if (shopInfoEdit) {
        <div class="flex align-items-center">
          <p-radioButton
            name="import"
            [value]="true"
            [(ngModel)]="shopInfoEdit.shopCanImport"
            (ngModelChange)="importModelChange()"
            inputId="actif" />
          <label for="actif" class="ml-2"> {{ "global.authorized" | translate }} </label>
        </div>

        <div class="flex align-items-center">
          <p-radioButton
            name="import"
            [value]="false"
            [(ngModel)]="shopInfoEdit.shopCanImport"
            (ngModelChange)="importModelChange()"
            inputId="notActif" />
          <label for="notActif" class="ml-2"> {{ "global.notAuthorized" | translate }} </label>
        </div>
      }
    </div>
   
  </div>
  <ng-template pTemplate="footer">
    <p-button
      type="button"
      icon="pi pi-times-circle"
      [outlined]="true"
      (click)="hideModalImport()"
      label="Annuler"
      severity="secondary"></p-button>
    <p-button
      type="button"
      icon="pi pi-check-square"
      [outlined]="importOutlined"
      (click)="submitImportForm()"
      label="Valider les modifications"></p-button>
  </ng-template>
</p-dialog>
@if (shopInfoEdit) {
  <p-dialog
    [dismissableMask]="true"
    header="Header"
    [(visible)]="scoreVisible"
    (onHide)="hideModalScore()"
    [modal]="true"
    [style]="{ width: '40rem' }"
    draggable="false">
    <ng-template pTemplate="header">
      <div class="inline-flex align-items-center justify-content-center gap-2">
        <span class="font-bold white-space-nowrap">{{ "shop.score" | translate }}</span>
      </div>
    </ng-template>
    <div>
      <div class="grid">
        <div class="lg:col-3 md:col-4 sm:col-4 flex align-items-center">
          <span class="mr-2">{{ "shop.scoreRef" | translate }}</span>
          <i class="pi pi-info-circle color-link-primary" pTooltip="{{ 'shop.refTooltip' | translate }}"></i>
        </div>
        <div class="lg:col-9 md:col-8 sm:col-8">
          <p-inputNumber
            #refValue
            [min]="0"
            [max]="100"
            (keypress)="scoreModelChange('scoreRef')"
            [(ngModel)]="shopInfoEdit.scoreRef"
            placeholder="Entrez une valeur"
            class="w-full block" />
        </div>

        <div class="lg:col-3 md:col-4 sm:col-4 flex align-items-center">
          <span class="mr-2">{{ "shop.scoreMedia" | translate }}</span>
          <i class="pi pi-info-circle color-link-primary" pTooltip="{{ 'shop.mediaTooltip' | translate }}"></i>
        </div>
        <div class="lg:col-9 md:col-8 sm:col-8">
          <p-inputNumber
            #mediaValue
            (keypress)="scoreModelChange('scoreMedia')"
            [min]="0"
            [max]="100"
            [(ngModel)]="shopInfoEdit.scoreMedia"
            placeholder="Entrez une valeur"
            class="w-full block" />
        </div>

        <div class="lg:col-3 md:col-4 sm:col-4 flex align-items-center">
          <span class="mr-2">{{ "shop.scoreAd" | translate }}</span>
          <i class="pi pi-info-circle color-link-primary" pTooltip="{{ 'shop.adTooltip' | translate }}"></i>
        </div>
        <div class="lg:col-9 md:col-8 sm:col-8">
          <p-inputNumber
            #adValue
            [min]="0"
            [max]="100"
            (keypress)="scoreModelChange('scoreAd')"
            [(ngModel)]="shopInfoEdit.scoreAd"
            placeholder="Entrez une valeur"
            class="w-full block" />
        </div>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <p-button
        type="button"
        icon="pi pi-times-circle"
        [outlined]="true"
        (click)="hideModalScore()"
        label="Annuler"
        severity="secondary"></p-button>
      <p-button
        type="button"
        icon="pi pi-check-square"
        [outlined]="scoreOutlined"
        (click)="submitScoreForm()"
        label="Valider les modifications"></p-button>
    </ng-template>
  </p-dialog>
}
<p-dialog
  [(visible)]="showAssociateDialog"
  header="{{ 'shop.associateAggregator' | translate }}"
  [dismissableMask]="false"
  [modal]="true"
  [style]="{ width: '40rem', height: '22rem' }"
  draggable="false">
  <div>
    <div class="grid mb-3">
      <div class="col-6 flex align-items-center">
        <span class="label-text-b">{{ "shop.selectAggregator" | translate }}</span>
      </div>
      <div class="col-6">
        <p-select
          [checkmark]="true"
          optionLabel="name"
          [showClear]="true"
          [(ngModel)]="selectedAggregator"
          [options]="allAggregators"
          placeholder="{{ 'shop.selectAggregator' | translate }}"
          appendTo="body"
          [disabled]="allAggregators.length == 0"
          [style]="{ width: '100%' }"
           />
      </div>
    </div>
    <div>
      <div class="block mb-3">
        <span class="label-text-b" [hidden]="allAggregators.length > 0">{{ "shop.allAggregatorAreAssociated" | translate }} </span>
      </div>
      @if(allAggregators.length != 0) {
        <span class="label-text-b">{{ "shop.finalizeAssociateAggregator" | translate }} </span>
        <p-button
          [text]="true"
          class="inline-flex vertical-align-middle"
          severity="secondary"
          ngxClipboard
          [cbContent]="selectedShop?.shopCode"
          (click)="toggleTooltip()"
          [pTooltip]="showTooltip ? this.translate.instant('global.copied') + ' &#10003;' : null"
          [tooltipPosition]="'right'">
          {{ selectedShop?.shopCode }}
          <i class="pi pi-copy pl-3"></i>
        </p-button>
      }
    
    </div>
  </div>
  <ng-template #footer>
    <p-button
      label="{{ 'buttons.cancel' | translate }}"
      [outlined]="true"
      severity="secondary"
      (onClick)="showAssociateDialog = false" />
    <p-button
      label="{{ 'buttons.confirm' | translate }}"
      (onClick)="associateAgregator(true)"
      [disabled]="selectedAggregator == null"
      [outlined]="false" />
  </ng-template>
</p-dialog>

<p-dialog
  [dismissableMask]="true"
  header="Header"
  [(visible)]="showChangeAssociationDialog"
  [modal]="true"
  [style]="{ width: '40rem' }"
  draggable="false">
  <ng-template pTemplate="header">
    <div class="inline-flex align-items-center justify-content-center gap-2">
      <span class="font-bold white-space-nowrap">{{ "global.importRight" | translate }}</span>
    </div>
  </ng-template>
  <div>
    <div class="grid">
      <div class="col-4">
        <span class="text-secondary">{{ "shop.importRightAggregatorStatus" | translate }}</span>
      </div>
      @if (selectedAggregator) {
        <div class="col-4">
          <p-radioButton name="import" [value]="true" [(ngModel)]="selectedAggregator.isAssociated" inputId="actif" />
          <label for="actif" class="ml-2"> {{ "global.authorized" | translate }} </label>
        </div>

        <div class="col-4">
          <p-radioButton
            name="import"
            [value]="false"
            [(ngModel)]="selectedAggregator.isAssociated"
            inputId="notActif" />
          <label for="notActif" class="ml-2"> {{ "global.notAuthorized" | translate }} </label>
        </div>
      }
      <div class="col-12">
        <span class="label-text-b">{{ "shop.finalizeAssociateAggregator" | translate }} : </span>
        <p-button
          [text]="true"
          class="inline-flex vertical-align-middle"
          severity="secondary"
          ngxClipboard
          [cbContent]="selectedShop?.shopCode"
          (click)="toggleTooltip()"
          [pTooltip]="showTooltip ? this.translate.instant('global.copied') + ' &#10003;' : null"
          [tooltipPosition]="'right'">
          {{ selectedShop?.shopCode }}
          <i class="pi pi-copy pl-3"></i>
        </p-button>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <p-button
      type="button"
      icon="pi pi-times-circle"
      [outlined]="true"
      label="{{ 'buttons.cancel' | translate }}"
      (click)="hideChangeAssociationDialog()"
      severity="secondary"></p-button>
    <p-button
      type="button"
      icon="pi pi-check-square"
      (click)="associateAgregator(selectedAggregator.isAssociated)"
      label="{{ 'buttons.validate' | translate }}"></p-button>
  </ng-template>
</p-dialog>

<p-toast />
<p-confirmDialog />
